import { supabaseClient } from '@auth-v2';
import { useMutation } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { toast } from 'sonner';

import { createLayout, LayoutCreate } from '@data';
import { queryClient, queryKeys } from '@queries';
import { activeUserIdAtom, currentUserIdAtom } from '@store';

export const useCreateNewLayout = () => {
    const userId = useAtomValue(currentUserIdAtom);
    const activeUserId = useAtomValue(activeUserIdAtom);
    return useMutation({
        mutationFn: async (payload: LayoutCreate) =>
            createLayout(supabaseClient, {
                userId: activeUserId === userId ? undefined : activeUserId,
                ...payload,
            }),
        onSuccess: () => {
            toast.success('Layout created successfully');
            if (!activeUserId) return;
            queryClient.invalidateQueries({
                predicate: (query) =>
                    queryKeys.layout.base(activeUserId).every((key, index) => query.queryKey[index] === key),
            });
        },
        onError: (error) => {
            toast.error(`Failed to create layout: ${error.message}`);
        },
    });
};
